import React, {useEffect, useState} from "react";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {IOperationResponse} from "@localization/siteMap/siteMapInterfaces.ts";
import {IconButton, Typography} from "@mui/material";
import {INotificacao} from "@models/conta/notificacao";
import {Notifications} from "@mui/icons-material";
import {Badge} from "@mui/joy";

export interface NotificacoesButtonProps {
    notificacoesOpen: boolean;
    setNotificacoesOpen: (open: boolean) => void;
}

export const NotificacoesButton: React.FC<NotificacoesButtonProps> = (props) => {
    const {getNotificacoes} = useAlert()
    const {setNotificacoesOpen, notificacoesOpen} = props
    const [notificacoes, setNotificacoes] = useState<IOperationResponse<INotificacao[]> | undefined>(undefined);
    const [hasNew, setHasNew] = useState<number>(0);

    useEffect(() => {
            const fetchNotificacoes = () => {
                const response = getNotificacoes();
                if (JSON.stringify(response?.pagination?.total) != JSON.stringify(notificacoes?.pagination?.total)) {
                    if (notificacoes != null) {
                        setHasNew((response.pagination.total) - (notificacoes?.pagination?.total ?? 0));
                    }
                    setNotificacoes(response);

                }
            };
            fetchNotificacoes();
        },
        [getNotificacoes],
    );
    return (
        <>
            <IconButton color={'primary'} onClick={() => {
                setNotificacoesOpen(!notificacoesOpen);
                setHasNew(0);
            }}>
                <Typography color={'inherit'} fontSize={'small'}>
                    {notificacoes?.pagination?.total}
                </Typography>
                <Badge size={'sm'} invisible={hasNew == 0} badgeContent={'+' + (hasNew)} max={99}>
                    <Notifications/>
                </Badge>

            </IconButton>
        </>
    )
}